import React, { PureComponent } from 'react'
import Dropzone from 'react-dropzone'
import CSSModules from 'react-css-modules'

import { normalizeLocalFiles } from 'helpers/pickerNormalizer'
import { getLocalFileTypesAccepted } from 'helpers/pickerFileTypesAcceptedProvider'
import { localize } from 'helpers/translator'

import styles from '../pick.scss'

class LocalPickerPick extends PureComponent {

	constructor() {
		super()
		this.openLocalUploadFiles = this.openLocalUploadFiles.bind(this)
		this.onDrop = this.onDrop.bind(this)
	}

	openLocalUploadFiles() {
		this.dropzone.open()
	}

	onDrop(acceptedFiles, rejectedFiles) {
		if (acceptedFiles.length > 0) {
			this.props.onChange(normalizeLocalFiles(acceptedFiles))
		} else if (rejectedFiles.length > 0) {
			this.props.onFileError(this.getErrorMessage())
		}
	}

	getErrorMessage() {
		const errorMessage = []
		if (this.props.accept.includes('image')) {
			errorMessage.push('.png, .jpg, .jpeg, .pjpeg, .gif, .bmp, .pdf')
		}
		if (this.props.accept.includes('image-nopdf')) {
			errorMessage.push('.png, .jpg, .jpeg, .gif, .bmp')
		}
		if (this.props.accept.includes('audio')) {
			errorMessage.push('.mp3, .ogg, .m4a, .wav, .aiff, .aif, .ac3, .aac, .wma')
		}
		if (this.props.accept.includes('video')) {
			errorMessage.push('.mpg, .mpeg, .mp4, .flv, .mov, .avi, .mpeg-1, .mpeg-2, .qt, .m4v, .wmv, .3gp, .asf, .ogv, .3gpp, .webm')
		}
		if (this.props.accept.includes('pdf')) {
			errorMessage.push('.pdf')
		}
		if (this.props.accept.includes('ppt')) {
			errorMessage.push('.ppt, .pptx, .odp, .pptm')
		}
		if (this.props.accept.includes('zip')) {
			errorMessage.push('.zip')
		}
		if (this.props.accept.includes('gif')) {
			errorMessage.push('.gif')
		}
		return `${localize('icon_validate_invalid_type')} ${errorMessage.join(', ')}`
	}

	render() {
		return (
			<Dropzone
				ref={node => {
					this.dropzone = node
				}}
				className={'hide'}
				disableClick={true}
				accept={getLocalFileTypesAccepted(this.props.accept)}
				onDrop={this.onDrop}
				multiple={this.props.multiselect}>
				<button styleName="picker-button" onClick={this.openLocalUploadFiles}>
					{this.props.children}
				</button>
			</Dropzone>
		)
	}
}

export default CSSModules(LocalPickerPick, styles, {allowMultiple: true})
